// extracted by mini-css-extract-plugin
module.exports = {"switcher":"switcher_switcher__WoO2E","switcher_toggle":"switcher_switcher_toggle__ejuWt"};